import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { GridHelper } from "../Common/Components/GridHelper";
import { ColumnMenu } from "../Common/Components/ColumnMenu";
import {
  GridColumnMenuFilter,
  GridColumnMenuCheckboxFilter,
} from "@progress/kendo-react-grid";

import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import moment from "moment";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { uniq, map, flatten } from "lodash";
import { DropDownList, ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";

import { useNavigate } from "react-router-dom";

const initialSort: any[] = [
  {
    field: "warrantyTo",
    dir: "desc",
  },
];

interface WarrantyGridProps {
  data?: any | null;
}

const WarrantyGrid = (props: WarrantyGridProps) => {
  const [data, setData] = useState(props.data);
  const [sort, setSort] = useState(initialSort);
    const [isPagable, updateIsPagable] = useState(false);
    const [filter, setFilter] = useState();
  const [page, setPage] = useState({
    skip: 0,
    take: 10,
  });
  const pageChange = (event) => {
    setPage(event.page);
  };

  const endDateCell = (cellProps: any) => {
    let color = "#c2ffc8";
    if (
      new Date(cellProps.dataItem.warrantyTo).getTime() < new Date().getTime()
    ) {
      color = "#ffa6a6";
    }

    return (
      <td style={{ backgroundColor: color }}>
        {moment(cellProps.dataItem.warrantyTo).format("DD.MM.YYYY")}
      </td>
    );
  };
  const startDateCell = (cellProps: any) => {
    return (
      <td>{moment(cellProps.dataItem.warrantyFrom).format("DD.MM.YYYY")}</td>
    );
  };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
    const filterChange = (event: any) => {
        if (props.data != null) {
            setData(filterBy(props.data, event.filter));
            setFilter(event.filter);
        }
    };

  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
                  pageable={isPagable}
                  // data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
                  data={Array.isArray(data) ? orderBy(data, sort) : []}
                  total={Array.isArray(data) ? data.length : 0}
                  // skip={page.skip}
                  // take={page.take}
                  //   onPageChange={pageChange}

                  filterable={true}
                  filter={filter}
                  //scrollable={"virtual"}
                  onFilterChange={filterChange}
                  sortable={true}
                  sort={sort}
                  onSortChange={(e: any) => {
                      setSort(e.sort);
                  }}
                  style={{
                      width: "100%",
                      height: "100%",
                  }}
        >
                  <Column field="machineSerial" title="Main Machine Serial" />
                  <Column field="deviceSerial" title="Device Serial" />
          <Column
            field="warrantyFrom"
            title="Warranty Start Date"
            cell={startDateCell}
          />

          <Column
            field="warrantyTo"
            title="Warranty End Date"
            cell={endDateCell}
          />
        </Grid>
      </ExcelExport>
    </div>
  );
};
export default WarrantyGrid;
